module.exports = __webpack_public_path__ + "img/waterpolo.7c063c56.svg";